import { render, staticRenderFns } from "./SuccessfulFlowModal.vue?vue&type=template&id=1b6f6b3b&scoped=true"
import script from "./SuccessfulFlowModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulFlowModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulFlowModal.vue?vue&type=style&index=0&id=1b6f6b3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f6b3b",
  null
  
)

export default component.exports